import { Link } from 'react-router-dom';

const col1 = [
  { label: '复盘档案', to: '/review' },
  { label: '深度复盘', to: '/event' },
  { label: '关于我们', to: '/about' },
];

const col2 = [
  { label: '反转如何发生', to: '/event#reversal' },
  { label: '各方回应拆解', to: '/event#responses' },
  { label: '后续进展追踪', to: '/event#progress' },
  { label: '吃瓜法律边界', to: '/review' },
];

export default function Footer() {
  return (
    <footer className="bg-accent-950 text-accent-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.6fr_1fr_1fr_1.2fr]">
          <div>
            <Link to="/" className="flex items-center gap-2.5" aria-label="99吃瓜 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-brand text-lg leading-none text-background-50">
                瓜
              </span>
              <span className="font-brand text-2xl leading-none text-background-50">
                99<span className="text-primary-400">吃瓜</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-6 text-accent-200/80">
              一家专注事件复盘与反转梳理的中文内容媒体。用时间线还原前因后果，拆解各方回应，持续跟进后续进展，陪你理性地把瓜吃明白。
            </p>
            <div className="mt-5 flex items-center gap-2 text-accent-200/80">
              <i className="ri-mail-line" aria-hidden="true" />
              <a href="mailto:hello@99chigua.example" className="text-sm hover:text-background-50" rel="nofollow">
                hello@99chigua.example
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50">栏目导航</h3>
            <ul className="mt-4 space-y-3">
              {col1.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-accent-200/80 transition-colors hover:text-background-50">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50">热门阅读</h3>
            <ul className="mt-4 space-y-3">
              {col2.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-accent-200/80 transition-colors hover:text-background-50">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50">理性吃瓜三原则</h3>
            <ul className="mt-4 space-y-3 text-sm text-accent-200/80">
              <li>· 事实先于情绪</li>
              <li>· 完整胜过片段</li>
              <li>· 结论不妨延后</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-accent-800/70 pt-6 text-xs text-accent-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 99吃瓜 · 本站内容为事件复盘与传播现象的理性分析，仅作信息交流，不构成对任何方的定论。</p>
          <Link to="/event" className="whitespace-nowrap text-accent-200/80 transition-colors hover:text-background-50">
            阅读本周深度复盘 →
          </Link>
        </div>
      </div>
    </footer>
  );
}